import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import ExtracaoConciliacaoSpedForm from "./ExtracaoConciliacaoSpedForm";
import ModalFilaCsvDinamica from "../ModalFilaCsvDinamica/ModalFilaCsvDinamica";
import Loading from "../Loading";
import { buscarRelatoriosPorCodigo } from "../../services/api-relatorios.service";

/**
 * Modal dedicada à extração Conciliação SPED (lista do Extrator).
 * Resolve idRelatorio via GET /relatorios/buscar-por-codigo/:codigo (sem hardcode).
 */
export default function ModalExtracaoConciliacaoSped({
  open,
  onClose,
  idRelatorio,
  codigoRelatorio,
  nomeRelatorio,
  onSucesso,
}) {
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const [nomeExibicao, setNomeExibicao] = useState(nomeRelatorio || "");
  const [idRelatorioResolvido, setIdRelatorioResolvido] = useState(undefined);
  const [relatorioCompleto, setRelatorioCompleto] = useState(null);

  const handleFinished = (sucesso, mensagem) => {
    if (sucesso) {
      onSucesso?.(mensagem);
      onClose();
    }
  };

  useEffect(() => {
    if (!open || !codigoRelatorio) {
      return;
    }

    let cancelled = false;
    setLoading(true);
    setErro(null);
    setNomeExibicao(nomeRelatorio || "");
    setIdRelatorioResolvido(undefined);
    setRelatorioCompleto(null);

    (async () => {
      try {
        const response = await buscarRelatoriosPorCodigo(codigoRelatorio);
        const rel = response?.relatorios?.[0];
        if (cancelled) return;
        if (!rel) {
          setErro("Relatório não encontrado.");
          return;
        }
        setNomeExibicao(rel.nome || nomeRelatorio || "");
        setRelatorioCompleto(rel);
        const rid = rel.idRelatorio;
        const fromApi =
          rid != null && rid !== "" && Number.isFinite(Number(rid))
            ? Number(rid)
            : NaN;
        const fromLista =
          idRelatorio != null &&
          idRelatorio !== "" &&
          Number.isFinite(Number(idRelatorio))
            ? Number(idRelatorio)
            : NaN;
        const resolved = Number.isFinite(fromApi) ? fromApi : fromLista;
        if (!Number.isFinite(resolved)) {
          setErro("Identificador do relatório inválido.");
          return;
        }
        setIdRelatorioResolvido(resolved);
      } catch (e) {
        if (!cancelled) {
          setErro(
            e?.response?.data?.mensagem ||
              e?.message ||
              "Não foi possível carregar o relatório."
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [open, codigoRelatorio, nomeRelatorio, idRelatorio]);

  const titulo =
    nomeExibicao || nomeRelatorio || "Conciliação SPED Contábil ECD x Contribuições";
  const mostrarFormulario =
    !loading && idRelatorioResolvido !== undefined && !erro;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <h4 style={{ margin: 0 }}>{titulo}</h4>
      </DialogTitle>
      <DialogContent>
        <Loading loading={loading} />
        {erro && (
          <Typography color="error" sx={{ py: 2 }}>
            {erro}
          </Typography>
        )}
        {mostrarFormulario &&
          (relatorioCompleto?.processaFilaCsv ? (
            <ModalFilaCsvDinamica
              relatorio={relatorioCompleto}
              onClose={onClose}
              onFinished={handleFinished}
            />
          ) : (
            <ExtracaoConciliacaoSpedForm
              idRelatorio={idRelatorioResolvido}
              onClose={onClose}
              onFinished={handleFinished}
            />
          ))}
      </DialogContent>
    </Dialog>
  );
}
